// $(document).ready(function() {
//     if ($(window).width() <  768) {
//          $('.footer_linklist_block ul').hide();
//          $('.footer_linklist_block h2').unbind().click(function() {
//              $('.footer_linklist_block h2').not($(this)).removeClass('active');
//              $('.footer_linklist_block ul').not($(this).siblings('.footer_linklist_block ul')).slideUp();
//              $(this).siblings('.footer_linklist_block ul').slideToggle();
//              $(this).toggleClass('active');
//         });
//     }
// });
//  $(window).resize(function() {
//     if ($(window).width() <  768) {
//          $('.footer_linklist_block ul').hide();
//          $('.footer_linklist_block h2').unbind().click(function() {
//              $('.footer_linklist_block h2').not($(this)).removeClass('active');
//              $('.footer_linklist_block ul').not($(this).siblings('.footer_linklist_block ul')).slideUp();
//              $(this).siblings('.footer_linklist_block ul').slideToggle();
//              $(this).toggleClass('active');
//         });
//     }
//     else {
//          $('.footer_linklist_block ul').show();
//     }
// });






    $('.footer_title').click(function () {
    if ($(window).width() <= 767) {
    $(this).parent().toggleClass('active').find('.footer_menu').slideToggle();
    $(this).parent().siblings().removeClass('active').find('.footer_menu').slideUp();
    }
    });

const slider_input = document.getElementById('slider_input'),
      slider_thumb = document.getElementById('slider_thumb'),
      slider_line = document.getElementById('slider_line');
var slider_outer_val = document.getElementById('rangeslider_outer_value');

slider_input.min = 1;

function showSliderValue() {
  
  slider_thumb.innerHTML = slider_input.value;
  const bulletPosition = (slider_input.value - slider_input.min) / (slider_input.max - slider_input.min),
        space = slider_input.offsetWidth - slider_thumb.offsetWidth;
  console.log(bulletPosition);
  
  slider_thumb.style.left = (bulletPosition * space) + 'px';
  slider_line.style.width = (slider_input.value - slider_input.min) / (slider_input.max - slider_input.min) * 100 + '%';

  let deliveryFrequency;
  if (slider_input.value >= 1 && slider_input.value <= 12) {
    deliveryFrequency = '3';
  } else if (slider_input.value >= 13 && slider_input.value <= 17) {
    deliveryFrequency = '2';
  } else {
    deliveryFrequency = '';
  }
  slider_outer_val.innerHTML = deliveryFrequency + ' mois';
  console.log(deliveryFrequency);

  var option_text = $("#appstle_selling_plan0 option:selected").text();
  console.log('aa' + option_text);
  
  setTimeout(function(){
  var option_text = $("#appstle_selling_plan0 option:selected").text();
  var match = option_text.match(/\((-?\d+)%\)/);
  if (match) {
    var percentage = parseInt(match[1]);

    var var_price_text = $(".appstle_subscription_compare_amount").text();
    console.log("asss" + var_price_text);
    var var_price = parseFloat(var_price_text.replace(/[^\d.-]/g, ''));
    console.log("Main Price:", var_price);

    if (percentage < 0) {
        percentage *= -1;
    }
    console.log("Percentage:", percentage);

    var discount_amount = (var_price * percentage) / 100;
    console.log("Discount Amount:", discount_amount.toFixed(2));

    var discount_main_price = var_price - discount_amount;

    var formatted_discount_price = (discount_main_price / 100).toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    }).replace(/\s/g, ''); // Remove any spaces from the formatted string

    console.log("Discounted Main Price:", formatted_discount_price);
    $(".appstle_subscription_amount_wrapper .appstle_subscription_amount").text(formatted_discount_price);
}
    }, 400);
    

  if (!deliveryFrequency) {
    $(".appstle_select option:first").prop('selected', true).trigger("change");

    $("#appstle_selling_plan0 option:selected").change();
    var vals = $("#appstle_selling_plan0 option:selected").val();
    console.log("aa" + vals);
    $("#appstle_subscription_widget0").attr("data-selected-selling-plan", vals);
    $("#appstle_selling_plan_label_20").val(vals);
    
    $("#appstle_selling_plan0").find('option[value="'+ vals +'"]').click();
    $("#appstle_selling_plan0").find('option[value="'+ vals +'"]').trigger("click");
    
  } else {
   $(".appstle_select option").filter(function() {
    return $(this).text().indexOf(deliveryFrequency) !== -1;
  }).prop('selected', true).trigger("change");
   $(".product-single__form select").find("option:selected").trigger("change");
    $("#appstle_selling_plan0 option:selected").change();
    var vals = $("#appstle_selling_plan0 option:selected").val();
    console.log("aa" + vals);
    $("#appstle_subscription_widget0").attr("data-selected-selling-plan", vals);
    $("#appstle_selling_plan_label_20").val(vals);
  }
  
    $(".variant_cart_details .form_data #delivery_day").val(deliveryFrequency);
 
}
showSliderValue();

window.addEventListener("resize", showSliderValue);
slider_input.addEventListener('input', showSliderValue, false);
